import React from "react";
import { useAuth } from "../../../state/AuthContext";

export default function CheckoutStatusModal() {
  const { checkoutStatus, setCheckoutStatus } = useAuth();

  if (checkoutStatus === "idle") return null;

  const isProcessing = checkoutStatus === "processing";
  const isSuccess = checkoutStatus === "success";
  const isFailed = checkoutStatus === "failed";

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="checkout-status-title"
    >
      <div className="w-full max-w-md rounded-2xl border border-neutral-200 bg-white p-6 shadow-2xl dark:border-neutral-800 dark:bg-neutral-950">

        {/* Status icon */}
        <div className="mb-4 flex justify-center">
          {isProcessing && (
            <div className="h-10 w-10 animate-spin rounded-full border-2 border-neutral-300 border-t-transparent dark:border-neutral-700" />
          )}

          {isSuccess && (
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400">
              ✓
            </div>
          )}

          {isFailed && (
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400">
              !
            </div>
          )}
        </div>

        {/* Title */}
        <h2
          id="checkout-status-title"
          className="text-center text-lg font-semibold tracking-tight text-neutral-900 dark:text-neutral-50"
        >
          {isProcessing && "Confirming purchase"}
          {isSuccess && "Pro access activated"}
          {isFailed && "Unable to confirm purchase"}
        </h2>

        {/* Body */}
        <p className="mt-2 text-center text-sm text-neutral-600 dark:text-neutral-300">
          {isProcessing &&
            "Please wait while we securely verify your payment and unlock your Pro features."}

          {isSuccess &&
            "Your payment was successful. All premium functionality is now available."}

          {isFailed &&
            "We could not confirm your purchase yet. If you were charged, please wait a moment and refresh or contact support."}
        </p>

        <p className="mt-2 text-center text-sm text-neutral-600 dark:text-neutral-300">
          If you have any issues, please contact support at{" "}
          <a
            href="mailto:support@diceframe.co.uk"
            className="text-blue-600 hover:underline dark:text-blue-400"
          >
            support@diceframe.co.uk
          </a>
        </p>

        {/* Actions */}
        <div className="mt-6 flex flex-col gap-2">
          {isProcessing ? (
            <button
              disabled
              className="w-full rounded-xl bg-neutral-100 px-4 py-2 text-sm font-semibold text-neutral-500 dark:bg-neutral-900 dark:text-neutral-400"
            >
              Processing…
            </button>
          ) : (
            <button
              onClick={() => setCheckoutStatus("idle")}
              className="w-full rounded-xl bg-black px-4 py-2 text-sm font-semibold text-white transition hover:opacity-90 dark:bg-white dark:text-black"
            >
              Continue
            </button>
          )}

          {isFailed && (
            <a
              href="mailto:support@diceframe.co.uk"
              className="w-full rounded-xl border border-neutral-200 px-4 py-2 text-center text-sm font-semibold text-neutral-800 hover:bg-neutral-100 dark:border-neutral-800 dark:text-neutral-100 dark:hover:bg-neutral-900"
            >
              Contact support
            </a>
          )}
        </div>
      </div>
    </div>
  );
}